module.exports = __webpack_public_path__ + "media/images/banner-dfb43757.jpg";